import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'repeatAddButton'
})
export class RepeatAddButtonPipe implements PipeTransform {

  transform(value: string): string {
    let label = '';
    switch (value) {
      case 'Vehicle':
        label = 'Add Another Vehicle';
        break;
      case 'Vehicles':
        label = 'Add Another Vehicle';
        break;
      case 'Driver':
        label = 'Add Another Driver';
        break;
      case 'Drivers':
        label = 'Add Another Driver';
        break;
      case 'Applicant':
        label = 'Add Another Applicant';
        break;
      case 'Applicants':
        label = 'Add Another Applicant';
        break;
      default:
        label = `Add ${value}`;
        break;
    }
    return label;
  }

}
